import Picture from "components/ui/picture"
import { jewlr_t } from "helpers/application"
import { getImgSrcSet } from "helpers/image"

const Packaging = () => (
  <>
    <div className="contained-wide widescreen:px-60 px-16">
      <h1 className="h1 mb-32">Gift Packaging</h1>
      <div
        className="widescreen:gap-100 desktop:flex-row desktop:py-60 desktop:text-center flex flex-col justify-center gap-32 py-16 text-left"
        style={{ "--desktop-max-width": "648px" }}
      >
        <div className="desktop:max-w-(--desktop-max-width) flex flex-1 flex-col gap-16">
          <Picture
            alt=""
            fallback="https://cms.jewlr.com/d_holiday_wrap_16e5a3fa18/d_holiday_wrap_16e5a3fa18.jpg"
            srcSet={[
              {
                height: 600,
                media: "(max-width: 1023px)",
                sizes: "100vw",
                srcSet: getImgSrcSet(
                  `${sl.config.jewlr_imgsmbly_url}cms/m_holiday_wrap_7ea493fa4c/m_holiday_wrap_7ea493fa4c.jpg`,
                  686
                ),
                width: 686,
              },
              {
                height: 732,
                media: "(min-width: 1024px)",
                sizes: "(max-width: 1532px) 50vw, 648px",
                srcSet: getImgSrcSet(
                  `${sl.config.jewlr_imgsmbly_url}cms/d_holiday_wrap_16e5a3fa18/d_holiday_wrap_16e5a3fa18.jpg`,
                  1588
                ),
                width: 1588,
              },
            ]}
          />
          <h2 className="h2">Holiday Gift Wrap + Card</h2>
          <p className="body">
            Wrap every moment in something meaningful. Our signature holiday
            gift wrap arrives in rich seasonal tones with a matching card that
            feels personal from the very first glance. The perfect finishing
            touch for a gift they&apos;ll cherish.
          </p>
        </div>
        <div className="desktop:max-w-(--desktop-max-width) flex flex-1 flex-col gap-16">
          <Picture
            alt=""
            fallback="https://cms.jewlr.com/d_holiday_wrap_16e5a3fa18/d_holiday_wrap_16e5a3fa18.jpg"
            srcSet={[
              {
                height: 600,
                media: "(max-width: 1023px)",
                sizes: "100vw",
                srcSet: getImgSrcSet(
                  `${sl.config.jewlr_imgsmbly_url}cms/m_love_wrap_6373f18413/m_love_wrap_6373f18413.jpg`,
                  686
                ),
                width: 686,
              },
              {
                height: 732,
                media: "(min-width: 1024px)",
                sizes: "(max-width: 1532px) 50vw, 648px",
                srcSet: getImgSrcSet(
                  `${sl.config.jewlr_imgsmbly_url}cms/d_love_wrap_dc97a82d98/d_love_wrap_dc97a82d98.jpg`,
                  1588
                ),
                width: 1588,
              },
            ]}
          />
          <h2 className="h2">Love Gift Wrap + Card</h2>
          <p className="body">
            Romantic, bold, unforgettable. This heart-covered gift wrap turns
            any piece into a love note they can hold. Beautifully printed and
            paired with a coordinating card for the sweetest reveal.
          </p>
        </div>
      </div>
    </div>
    <div className="bg-grey-4">
      <div className="contained-wide widescreen:px-60 desktop:py-60 flex flex-col items-center justify-center gap-16 px-16 py-32 text-center">
        <div className="desktop:gap-16 flex flex-col justify-center gap-8">
          <h2 className="h2">{jewlr_t("terms.Personalized")} Photo Box</h2>
          <p
            className="body desktop:max-w-(--desktop-max-width)"
            style={{ "--desktop-max-width": "768px" }}
          >
            Upgrade to our {jewlr_t("terms.personalized")}{" "}
            {jewlr_t("terms.jewelry")} box! Upload a {jewlr_t("terms.favorite")}{" "}
            photo or choose a custom design, and we&apos;ll print the image
            directly on your {jewlr_t("terms.jewelry")} box to create a
            one-of-a-kind keepsake.*
          </p>
        </div>
        <div
          className="desktop:max-w-(--desktop-max-width) aspect-(--base-aspect-ratio) w-full"
          style={{
            "--base-aspect-ratio": "1920 / 1080",
            "--desktop-max-width": "574px",
          }}
        >
          <video
            className="lazyload w-full"
            data-autoplay
            data-poster={`${sl.config.jewlr_asset_url}packaging/holiday-2025/customize_box_thumb.jpg`}
            loop
            muted
            playsInline
            preload="none"
          >
            <source
              src={`${sl.config.jewlr_asset_url}packaging/holiday-2025/customize_box.webm`}
              type="video/webm"
            />
            <source
              src={`${sl.config.jewlr_asset_url}packaging/holiday-2025/customize_box.mp4`}
              type="video/mp4"
            />
          </video>
        </div>
        <p
          className="body desktop:max-w-(--desktop-max-width)"
          style={{ "--desktop-max-width": "526px" }}
        >
          *Available for select items only. Look for the option to upgrade on
          the product page when you {jewlr_t("terms.personalize")} your piece.
        </p>
      </div>
    </div>
    <div className="contained-wide widescreen:px-60 desktop:flex-row flex flex-col items-center justify-center gap-24 px-16 py-32">
      <div
        className="desktop:max-w-(--desktop-max-width) w-full"
        style={{ "--desktop-max-width": "438px" }}
      >
        <Picture
          alt=""
          fallback="https://cms.jewlr.com/d_cleaning_kit_7050f95580/d_cleaning_kit_7050f95580.jpg"
          srcSet={[
            {
              height: 600,
              media: "(max-width: 1023px)",
              sizes: "100vw",
              srcSet: getImgSrcSet(
                `${sl.config.jewlr_imgsmbly_url}cms/m_cleaning_kit_39990bc8d5/m_cleaning_kit_39990bc8d5.jpg`,
                686
              ),
              width: 686,
            },
            {
              height: 1000,
              media: "(min-width: 1024px)",
              sizes: "438px",
              srcSet: getImgSrcSet(
                `${sl.config.jewlr_imgsmbly_url}cms/d_cleaning_kit_7050f95580/d_cleaning_kit_7050f95580.jpg`,
                874
              ),
              width: 874,
            },
          ]}
        />
      </div>
      <div className="desktop:gap-24 flex flex-col items-start justify-center gap-8">
        <h2 className="h2">Jewlr Foaming {jewlr_t("terms.Jewelry")} Cleaner</h2>
        <p
          className="body desktop:max-w-(--desktop-max-width)"
          style={{ "--desktop-max-width": "464px" }}
        >
          Give your {jewlr_t("terms.jewelry")} a fresh start with our Foaming{" "}
          {jewlr_t("terms.Jewelry")} Cleaner. This gentle, mess-free formula
          lifts away dirt and oils so every stone and metal surface shines like
          new. Perfect for maintaining the pieces they love.
        </p>
      </div>
    </div>
  </>
)
export default Packaging
